"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icon = _interopRequireDefault(require("../utils/icon.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

var originList = _icon.default.map(function (name) {
  return "el-icon-".concat(name);
});
var _default = exports.default = {
  inheritAttrs: false,
  props: ['current'],
  data: function data() {
    return {
      iconList: originList,
      active: null,
      key: ''
    };
  },
  watch: {
    key: function key(val) {
      if (val) {
        this.iconList = originList.filter(function (name) {
          return name.indexOf(val) > -1;
        });
      } else {
        this.iconList = originList;
      }
    }
  },
  methods: {
    onOpen: function onOpen() {
      this.active = this.current;
      this.key = '';
    },
    onClose: function onClose() {},
    onSelect: function onSelect(icon) {
      this.active = icon;
      this.$emit('select', icon);
      this.$emit('update:visible', false);
    }
  }
};